<template>
  <div class="footer">
      <div class="footer_container">
        <div class="grid footer_group ">
           
            <div class="grid_md_3 grid_sm_12 grid_xs_12 group_wrapper">
                <div class="wrapper_title flex">
                    <!-- <div class="title_icon"><img src="../assets/icon/zhonghefuwu.png" alt=""></div> -->
                    <div class="title_text">{{ $t('key92') }}</div>
                </div>
                <div class="wrapper_item flex" v-for="(item,index) in serveList" :key="index">
                    <div class="wrapper_link_tab" @click="toPage(item.remark,item.id)" v-if="item.showStatus==1">{{ item.serviceName }}</div> 
                </div>
                 <div class="wrapper_item flex" >
                    <div class="wrapper_link_tab" @click="toPage('aml-policy')" > Aml-Policy </div> 
                </div>
            
            </div>
            <div class="grid_md_6 grid_sm_12 grid_xs_12 group_wrapper">
                <div class="wrapper_title flex">
                    <!-- <div class="title_icon"><img src="../assets/icon/youqinglianjie.png" alt=""></div> -->
                    <div class="title_text">{{ $t('key14') }}</div>
                </div>
                <div><p>HUGGIFTS LLC</p></div>
                <div style="margin:10px 0;"><p>1942 Broadway St. STE 314C Boulder CO 80302</p></div>
                <div style="margin:10px 0;"><p>info@huggifts.com</p></div>
                
            </div>
            <div class="grid_md_3 grid_sm_12 grid_xs_12 group_wrapper flex_col_sb">
                <div class="wrapper_title flex">
                   
                </div>
                
                <div class="wrapper_item flex">
                   <div class="item_icon">
                    <a href="https://discord.gg" target="_blank">
                        <img src="../assets/icon/guanzhu_1.png" alt="">
                    </a>
                     
                   </div>
                   <div class="item_icon">
                    <a href="https://www.tiktok.com" target="_blank">
                        <img src="../assets/icon/guanzhu_2.png" alt="">
                    </a>
                     
                   </div>
                   <div class="item_icon">
                    <a href="https://x.com" target="_blank">
                        <img src="../assets/icon/guanzhu_3.png" alt="">
                    </a>
                     
                   </div>
                   <div class="item_icon">
                    <a href="https://www.youtube.com" target="_blank">
                        <img src="../assets/icon/guanzhu_4.png" alt="">
                    </a>
                     
                   </div>
                </div>
               
                
            </div>
        </div>
        <!-- <div class="mobile_footer_group hidden-sm-and-up">
            <el-collapse accordion>
              
                <el-collapse-item>
                    <template slot="title">
                    <div class="wrapper_title flex">
                    
                        <div class="title_text">{{ $t('key92') }}</div>
                    </div>
                    
                    </template>
                    <div class="coll_container">
                        <div class="wrapper_item flex" v-for="(item,index) in serveList" :key="index">
                            <div class="wrapper_link_tab" @click="toPage(item.remark,item.id)" v-if="item.showStatus==1">{{ item.serviceName }}</div> 
                        </div>
                     
                    </div>
                </el-collapse-item>
            </el-collapse>
            <div class="group_wrapper" style="padding:16px 0;">
                <div class="wrapper_title flex">
               
                    <div class="title_text">LootbarUs</div>
                </div>
                <div><p>1099 18th St Suite 2900</p></div>
                <div><p>Denver, CO 80202</p></div>
                <div style="margin:20px 0;"><p>info@lootbar.us</p></div>
                <div class="wrapper_item flex">
                   <div class="item_icon">
                    <a href="https://discord.gg" target="_blank">
                        <img src="../assets/icon/guanzhu_1.png" alt="">
                    </a>
                   </div>
                   <div class="item_icon">
                    <a href="https://www.tiktok.com" target="_blank">
                        <img src="../assets/icon/guanzhu_2.png" alt="">
                    </a>
                   </div>
                   <div class="item_icon">
                    <a href="https://x.com" target="_blank">
                        <img src="../assets/icon/guanzhu_3.png" alt="">
                    </a>
                   </div>
                   <div class="item_icon">
                    <a href="https://www.youtube.com" target="_blank">
                        <img src="../assets/icon/guanzhu_4.png" alt="">
                    </a>  
                   </div>
                </div>  
            </div>
        </div> -->
      </div>
      <!-- <div class="login_hidden empty"></div> -->
  </div>
</template>

<script>
import {processString} from '../utils/tool'
export default {
    data(){
        return{
       
            pageIndex:1,
            pageSize:10,
            // serveList:[],
            navigationList:[]

        }
    },
    created(){
    //    this.getSerConfig()
       this.getNavigationList()
    //    this.configServiceTranslation()
    },
    methods:{
        toPage(path,id,allName){
            let lang = localStorage.getItem('lang')
            console.log('path',path,id,allName)
            
            if(id){      
                let tranName = allName
                let name = ''
                let gameName = ''
                if(allName && !/^\s*$/.test(allName)){
                    console.log('allName  allNameallNameallName',!/^\s*$/.test(allName))
                    if(typeof(allName) === 'string'){
                        tranName = JSON.parse(allName)
                    }            
                    tranName.map(c=>{
                    if(c.language =='1' ){
                        name = c.name
                    }  
                    })
                }
                
                gameName = processString(name)
                this.$router.push(path+'/'+lang+'/'+id+'/'+gameName)
            
                return
            }
            this.$router.push(path+'/'+lang)
        },
        
        getNavigationList(){                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   
            let localeUrl = window.location.host
            let domain = 'https://'+localeUrl
            this.$axiosApi.navigationList({domain}).then(res=>{
                if(res.code == 200){
                  let data = res.data
                
                  this.navigationList = data.map(v=>{
                    if(!/^\s*$/.test(v.site)){
                       v.site = JSON.parse(v.site)         
                       let lang = this.$store.state.lang.dictValue
                       v.site.map(s=>{
                        if(s.language == lang){
                            v.transName = s.name
                        }
                       })
                    }
                   
                    return v
                  })
                 
                }
            })
        },
        getSerConfig(){
            let language = this.$store.state.lang.dictValue
            let _this = this
            if(!language){
                setTimeout(()=>{
                    _this.getSerConfig()
                },1000)
                return
            }
            let pageIndex = 1
            let pageSize = 10
            let localeUrl = window.location.host
            let domain = 'https://'+localeUrl
           
            console.log('domain',domain,localeUrl)
            this.$axiosApi.serConfig({pageIndex,pageSize,language,domain}).then(res=>{
            
            this.serveList = res.data.list
            })
        },
        configServiceTranslation(){
            let localeUrl = window.location.host
            let domain = 'https://'+localeUrl
            let target_lang = localStorage.getItem('lang')
            let lang = this.$store.state.lang.dictValue
            this.$axiosApi.configServiceTranslation({domain,target_lang,lang}).then(res=>{

            })
        }

    },
    computed:{
        serveList(){ return this.$store.state.serveList}
    }
}
</script>

<style lang='scss' scoped>
.footer{
   padding:32px 0;
    // background:#f0f0f7;
    margin-top: 32px;
    margin-bottom: 52px;
    .footer_container{
        width:100%;
        text-align: left;
       .footer_group{
        grid-column-gap:16px;
        grid-row-gap:16px;
      
       }
      
    }
    .group_wrapper{
           
           .wrapper_title{
               margin-bottom: 8px;
               padding: 13px 0;
               .title_icon{
                   width:20px;
                   height: 20px;
               }
               .title_text{
                   color:#fff;
                   font-weight: 600;
                   line-height: 22px;
                   font-size: 18px;
               }
           }
           .wrapper_item{
               .item_icon{
                   width: 40px;
                   height: 40px;
                   border-radius: 50%;
                   transition: all .15s linear;
                   margin-right:32px;
                   cursor: pointer;
                   overflow: hidden;
                   >img{
                       transition: all .15s linear;
                   }
                   &:hover{
                       >img{
                           transform: scale(1.1);
                       }
                   }
                   &:nth-child(4){
                       margin:0;
                   }
               }
               .wrapper_link_tab{
                //    color:#0f0f0f;
                   font-size: 14x;
                  
                   cursor: pointer;
                   &:hover{
                       text-decoration: underline
                   }
               }
               .wrapper_cont{
                  
                   padding: 4px 12px;
                   height: 32px;
                   border: 1px solid #d2d3d4;
                   border-radius: 100px;
                   box-sizing: border-box;
                   transition: all .15s linear;
                   cursor: pointer;
                   &:hover{
                    //    background:#dcdee5;
                    background-color: #ffffff10;
                   }
               }
               
               white-space: nowrap;
               text-overflow: ellipsis;
               overflow-x: hidden;
            //    color:#0f0f0f;
               margin-top:8px;
               .wrapper_tab{
                   font-size:14px;
               }
               
               .tab_icon{
                   
                   width: 16px;
                   height: 16px;
               }
           }
       }
    .empty{
        height: 100px;

    }
    .mobile_footer_group{
        padding:0 16px;
        // background:#fff;
        .wrapper_cont{    
            margin-right:10px; 
            margin-bottom:10px; 
            padding: 4px 12px;
            height: 32px;
            border: 1px solid #d2d3d4;
            border-radius: 100px;
            box-sizing: border-box;
            transition: all .15s linear;
            cursor: pointer;
            &:hover{
                background:#dcdee5;
            }
            .tab_icon{
                width: 20px;
                height: 20px;
            }

        }
        .coll_container{
            
            .wrapper_item{
                padding:18px 20px;
                border-bottom:1px solid #e8e9ed;
            }
        }
    }
    /deep/.el-collapse-item__header {
        height: 56px;
        line-height: 56px;
        color:#fff;
        background-color: #ffffff10;
    }
    /deep/ .el-collapse-item__content{
        // background-color: #ffffff10;
        color:#fff;
    }
    /deep/.el-collapse-item__wrap{
        background-color: #ffffff10;
    }
}
@media screen and (max-width:768px){
    .footer{
        // margin-left: -16px;
        // margin-right:-16px;
       
    }
}

</style>